import React__default from "react";

function getRefProp(element) {
  var _a;

  const version = React__default.version;

  if (typeof React__default.version !== "string") {
    return element == null ? void 0 : element.ref;
  }

  if (version.startsWith("18.")) {
    return element == null ? void 0 : element.ref;
  }

  return (_a = element == null ? void 0 : element.props) == null ? void 0 : _a.ref;
}

export { getRefProp };